<script>
export default {
    props: ['data'],
    name: "newsSwiperList",
    data() {
        return {
            swiperOptions1: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: '3.58%',
            },
            swiperOptions2: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                // slidesPerView: 4,
                // slidesPerGroup: 4,
                // spaceBetween: '3.58%',
                // spaceBetween: '3.58%',
                pagination: {
                    el: '.swiper-pagination',
                },
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="news_swiper_list_wrapper">
        <!-- pc -->
        <swiper class="news_swiper_list only_pc" ref="mySwiper" :options="swiperOptions1">
            <swiper-slide v-for="(item, index) in data" :key="index">
                <router-link class="item" :to="`/news/detail?id=${item.id}`">
                    <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                    <div class="name">{{ item.name }}</div>
                </router-link>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
        <!-- mobile -->
        <swiper class="news_swiper_list only_mobile" ref="mySwiper" :options="swiperOptions2">
            <swiper-slide v-for="(item, index) in data" :key="index">
                <router-link class="item" :to="`/news/detail?id=${item.id}`">
                    <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                    <div class="name">{{ item.name }}</div>
                </router-link>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>

<style scoped lang="scss">
.news_swiper_list{
    padding: 0 .4rem;
    @media only screen and (max-width: 750px) {
        padding: 0;
        width: 7.5rem;
        margin: 0 -.3rem;
    }
    .item{
        // flex: 1;
        // width: 2.5rem;
        text-align: center;
        // display: flex;
        // flex-direction: column;
        gap: .2rem;
        display: block;
        .bg{
            height: 0;
            padding-bottom: 100%;
            margin-bottom: .2rem;
            // 
            // border: 1px solid #000;
        }
        .name{
            font-size: .18rem;
        }
        @media only screen and (max-width: 750px) {
            padding: 0 .3rem;
            .bg{
                width: 100%;
                height: 4.5rem;
                padding-bottom: 0;
                margin-bottom: .3rem;
            }
            .name{
                font-size: .3rem;
            }
        }
    }
    --swiper-navigation-color: #999;/* 单独设置按钮颜色 */
    --swiper-navigation-size: .26rem;/* 设置按钮大小 */
    .swiper-button-prev,
    .swiper-button-next{
        top: 1.26rem;
        margin-top: 0;
        transform: translate(0, -50%);
        padding: .2rem;
        &.swiper-button-disabled{
            opacity: 0;
        }
        @media only screen and (max-width: 750px) {
            top: 2.25rem;
            padding: .15rem;
        }
    }
    .swiper-button-prev{
        left: 0;
    }
    .swiper-button-next{
        right: 0;
    }
    .swiper-pagination{
        display: flex;
        justify-content: center;
        gap: .1rem;
        top: 4.1rem;
        /deep/ .swiper-pagination-bullet{
            opacity: 1;
            margin: 0;
            width: .12rem;
            height: .12rem;
            background: none;
            border: 1px solid #fff;
            &-active{
                background: #fff;
            }
        }
    }
}
</style>